import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'
import CloseIcon from '@mui/icons-material/Close'

import Icon from '../components/Icon'

import { UI } from '../config'

import '../styles/SearchInput.scss'

export default class SearchInput extends Component {

  static propTypes = {
    onChange: PropTypes.func,
    onToggle: PropTypes.func,
    searchQuery: PropTypes.string,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    minCharacters: PropTypes.number,
    variant: PropTypes.oneOf(['default', 'unified']),
  }

  static defaultProps = {
    onChange: null,
    onToggle: null,
    searchQuery: '',
    autoFocus: true,
    disabled: false,
    placeholder: 'Search',
    minCharacters: UI.SEARCH_MIN_CHARACTERS,
    variant: 'default',
  }

  input = null

  constructor(props) {
    super(props)

    this.state = {
      query: this.props.searchQuery
    }

    this.handleChangeDelayed = _.debounce(this.handleChangeDelayed.bind(this), UI.SEARCH_BOX_DELAY)
  }

  clearSearchQuery = () => {
    this.setState({query: ""})
    this.props.onChange("")
  }

  handleChange = (event) => {
    if (this.props.disabled) return
    this.setState({query: event.target.value})
    this.handleChangeDelayed()
  }

  handleFocus = () => {
    if (this.props.onToggle) this.props.onToggle(true)
  }

  handleBlur = () => {
    if (this.props.onToggle) setTimeout(() => this.props.onToggle(false), UI.FRAME_DELAY)
  }

  /**
   * Initiate change event with delay
   */
  handleChangeDelayed() {
    const len = this.state.query.length
    const minCharacters = this.props.minCharacters

    if (len > 0 && len < minCharacters) {
      return
    }

    this.props.onChange(this.state.query.trim())
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchQuery !== this.props.searchQuery && this.props.searchQuery !== this.state.query) {
      this.setState({ query: this.props.searchQuery })
    }
  }

  componentDidMount() {
    if (this.props.autoFocus && !this.props.disabled) {
      setTimeout(() => {
        if (this.input) {
          // set carret position to the end of searchQuery
          if (this.state.query) {
            let caretPos = this.state.query.length

            if (typeof this.input.createTextRange !== 'undefined') {
              let range = this.input.createTextRange()
              range.move('character', caretPos)
              range.select()
            } else {
              if (typeof this.input.selectionStart !== 'undefined') {
                this.input.focus()
                this.input.setSelectionRange(caretPos, caretPos)
              } else {
                this.input.focus()
              }
            }
          } else
            this.input.focus()

        }
      }, UI.ANIMATION_DELAY)
    }
  }

  render() {
    const { placeholder, variant, disabled } = this.props
    const isUnified = variant === 'unified'

    return (
      <div className={classNames('SearchInput', isUnified && 'SearchInput--unified', disabled && 'is-disabled')}>
        <Icon type={isUnified ? 'search-unified' : 'search'}/>
        <input
          type="text"
          ref={input => this.input = input}
          value={this.state.query}
          placeholder={placeholder}
          disabled={disabled}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        {!isUnified && this.state.query ? (
          <button className="cancel-search" onClick={this.clearSearchQuery}><Icon type="cancel"/></button>
        ) : null}
        {isUnified && this.state.query && !disabled ? (
          <button
            type="button"
            className="SearchInput-clear"
            onClick={this.clearSearchQuery}
            aria-label="Clear search"
          >
            <CloseIcon />
          </button>
        ) : null}
      </div>
    )
  }
}
